import React from "react";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="copyright">
        Copyright &copy; 2019-{new Date().getFullYear()} Argali Knowledge
        Services Pvt. Ltd.
      </div>
    </footer>
  );
};

export default Footer;
